import React, { Component } from "react";
import roadMapData from "../../assets/js/roadMapData";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"
import "./css/Diagram.css";


SwiperCore.use([Navigation]);

class Diagram extends Component {

    render() {
        return (
            <>
                <div className="nk-block">
                    <div className="roadmap-wrap roadmap-wrap-ovl-right text-center">
                        <div className="roadmap-line-s2"></div>
                        <Swiper
                            slidesPerView={3}
                            navigation={{
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev'
                            }}
                            scrollbar={{ draggable: true }}
                            breakpoints={{
                                120: {
                                    slidesPerView: 1,
                                },
                                320: {
                                    slidesPerView: 1,
                                },
                                480: {
                                    slidesPerView: 1,
                                },
                                575: {
                                    slidesPerView: 2,
                                },
                                767: {
                                    slidesPerView: 2,
                                },
                                992: {
                                    slidesPerView: 3,
                                },
                                1199: {
                                    slidesPerView: 4,
                                }
                            }}
                        >
                            {roadMapData.map((el, i) => {
                                return (
                                    <SwiperSlide key={i}>
                                        <div className={el.status === "running" ? "roadmap roadmap-s2 roadmap-running" : (el.status === "finished" ? "roadmap roadmap-s2 roadmap-finished" : "roadmap roadmap-s2")}>
                                            <h6 className="roadmap-year-s2">{el.year}</h6>
                                            <h5 className="title title-sm roadmap-range">{el.range}</h5>
                                            <div className="roadmap-text">
                                                <p>{el.content}</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>
                    <div className="me-testimonial-button">
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div>
                    </div>
                </div>
            </>
        );
    }
}

export default Diagram;